import React from 'react';
import { Card } from 'antd';
import {
  RiseOutlined,
  FallOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  CalculatorOutlined
} from '@ant-design/icons';

interface StatisticCardProps {
  title: string;
  value: number | string;
  change: number;
  changeText?: string;
  type: 'revenue' | 'orders' | 'price' | 'customers';
  loading?: boolean;
}

const StatisticCard: React.FC<StatisticCardProps> = ({
  title,
  value,
  change,
  changeText,
  type,
  loading = false
}) => {
  const getIcon = () => {
    switch (type) {
      case 'revenue':
        return <DollarOutlined style={{ fontSize: 24, color: '#1890ff' }} />;
      case 'orders':
        return <ShoppingOutlined style={{ fontSize: 24, color: '#ff7a45' }} />;
      case 'price':
        return <CalculatorOutlined style={{ fontSize: 24, color: '#722ed1' }} />;
      case 'customers':
        return <UserOutlined style={{ fontSize: 24, color: '#52c41a' }} />;
      default:
        return null;
    }
  };

  const getValueColor = () => {
    switch (type) {
      case 'revenue':
        return '#1890ff';
      case 'orders':
        return '#ff7a45';
      case 'price':
        return '#722ed1';
      case 'customers':
        return '#52c41a';
      default:
        return undefined;
    }
  };

  const formatValue = (val: number | string) => {
    if (typeof val === 'number' && type === 'revenue') {
      return `¥${val.toLocaleString()}`;
    }
    if (typeof val === 'number' && type === 'price') {
      return `¥${val.toLocaleString()}`;
    }
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    return val;
  };

  const changeColor = change >= 0 ? '#52c41a' : '#ff4d4f';
  const ChangeIcon = change >= 0 ? RiseOutlined : FallOutlined;

  return (
    <Card loading={loading} style={{ height: '140px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '14px',
            color: '#666',
            marginBottom: '8px'
          }}>
            {title}
          </div>
          <div style={{
            fontSize: '28px',
            fontWeight: 'bold',
            color: getValueColor(),
            marginBottom: '8px'
          }}>
            {formatValue(value)}
          </div>
          <div style={{
            fontSize: '12px',
            color: changeColor,
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}>
            <ChangeIcon />
            <span>{Math.abs(change)}%</span>
            <span style={{ color: '#999', marginLeft: '4px' }}>
              {changeText || '较上期'}
            </span>
          </div>
        </div>
        <div>
          {getIcon()}
        </div>
      </div>
    </Card>
  );
};

export default StatisticCard;
